<template>
    <div component="Gallery">
        <page-header :icon="'camera_alt'" :text="'My Face'"></page-header>
        <section container="detail">
            <div class="buttons">
                <a
                    class="button camera"
                    :state="getShowCamera ? 'load' : ''"
                    color="accent"
                    @click="showCameraProfile($event, true)"
                >
                    <i class="icon">camera_alt</i><span>CAMERA</span>
                </a>
                <input type="file" id="photoFile" ref="photoFile" :accept="mimes.join(',')" @change="photoSelected" />
                <a class="button" size="" color="primary" @click="openPhotoSelect">
                    <i class="icon">add</i><span>ADD NEW FILE</span>
                </a>
            </div>
            <crop-pop-up
                v-show="showCropper"
                :loading="[states.uploading].includes(state)"
                @save="uploadFile"
                @close="showCropper = false"
                ref="cropPopUp"
            />
            <!-- <image-slider class="insideSlider" :images="getActorGallery" :hasBackground="true"></image-slider> -->
            <section container="list">
                <save-progress-indicator :state="state" />
                <div v-bar class="vb">
                    <div>
                        <draggable
                            delay="0"
                            class="draggable my-images"
                            :class="{
                                dragging: [states.dragging].includes(state),
                                saving: [states.saving].includes(state),
                                saved: [states.saved].includes(state),
                            }"
                            v-model="images"
                            @start="dragStart"
                            @end="dragEnd"
                            handle=".handle"
                        >
                            <thumbnail
                                class="thumbnail"
                                @click="selectImage"
                                @edit="editImage"
                                @remove="removeImage"
                                v-for="(item, index) in images"
                                :key="item.file_id"
                                :image="item"
                                :index="index"
                            />
                        </draggable>
                    </div>
                </div>
            </section>
        </section>
    </div>
</template>
<script>
import { mapGetters, mapActions, mapMutations } from 'vuex';
import PageHeader from '@/components/Profile/ProfileDetailHeader.vue';
import Thumbnail from '@/components/Profile/Gallery/Thumbnail.vue';
import CropPopUp from './Cropper/CropPopUp.vue';
import draggable from 'vuedraggable';
import SaveProgressIndicator from '@/components/.global/SaveProgressIndicator.vue';
import { PhotoModel } from '@model/Actor/PhotoModel';
import { ActorsApi } from '@/api';

const states = {
    idle: 'idle',
    uploading: 'uploading',
    deleting: 'deleting',
    deleted: 'deleted',
    dragging: 'dragging',
    saving: 'saving',
    saved: 'saved',
    error: 'error',
};

export default {
    name: 'Gallery',

    components: {
        PageHeader,
        Thumbnail,
        CropPopUp,
        draggable,
        SaveProgressIndicator,
    },

    data() {
        return {
            states,
            state: states.idle,
            mimes: ['image/jpeg', 'image/png'],
            image: null,
            images: [],
            editingIndex: null,
            showCropper: false,
        };
    },

    mounted() {
        this.readImages();
        this.$_eventsSubscribe({ cropSaved: 'uploadFile' });
    },

    methods: {
        ...mapActions(['uploadActorPhoto', 'savePhotoToActorGallery', 'saveActorGallery', 'loadActorGallery']),
        ...mapMutations(['setImageSliderIndex', 'showCamera', 'setActorGallery']),

        readImages() {
            this.images = this.getActorGallery;
        },

        showCameraProfile(event, val) {
            if (!this.getShowCamera) {
                this.showCamera(val);
            }
        },

        dragStart(e) {
            this.$_setState(states.dragging);
        },

        dragEnd(e) {
            this.$_setState(states.idle);
            this.setActorGallery(this.images);
            this.reorder();
        },

        setCropper(image) {
            this.showCropper = true;
            this.$refs.cropPopUp.replace(image);
        },

        editImage(index) {
            this.editingIndex = index;
            this.image = this.images[index];
            this.setCropper(this.images[index].url);
        },

        selectImage(index) {
            this.setImageSliderIndex(index);
        },

        openPhotoSelect() {
            this.$refs.photoFile.click();
        },

        async removeImage(image) {
            this.images = this.images.filter((i) => i != image);
            this.setActorGallery(this.images);
            this.$_setState(states.deleting);
            try {
                await ActorsApi.removeActorPhoto(image);
                this.$_setState(states.deleted, states.idle);
                this.readImages();
                this.setImageSliderIndex(Math.max(0, parseInt(this.getImageSliderIndex) - 1));
            } catch (e) {
                this.$_setState(states.error, states.idle);
                throw e;
            }
        },

        photoSelected(event) {
            if (!event.target.files[0].type.includes('image/')) {
                alert('Zvoľte obrázkovy súbor');
                return;
            }

            const selectedFile = event.target.files[0];

            if (typeof FileReader === 'function') {
                const reader = new FileReader();

                reader.onload = (event) => {
                    this.setCropper(event.target.result);
                };

                reader.readAsDataURL(selectedFile);
            } else {
                this.uploadFile(selectedFile);
            }
        },

        async uploadFile(file) {
            if (!file.type.includes('image/')) {
                alert('Zvoľte obrázkovy súbor');
                return;
            }

            this.$_setState(states.uploading);

            try {
                const { data } = await ActorsApi.createActorPhoto(
                    this.getActor,
                    {
                        poradie: 0,
                    },
                    file
                );

                const record = new PhotoModel(data);

                this.getActor.addPhoto(record);
                await this.reorder();
            } catch (e) {
                this.$_setState(states.error, states.idle);
                this.$env.log.error(e);
                this.$bugsnag.notify(e);
            } finally {
                if (this.showCropper) {
                    this.showCropper = false;
                }
            }
        },

        async reorder() {
            if (this.$_stateIs(states.saving)) {
                return;
            }

            this.getActor.reorderPhotos();

            this.$_setState(states.saving);

            try {
                await this.getActor.saveGallery();
                await this.loadActorGallery();
                this.readImages();
                this.$_setState(states.saved);
            } catch (e) {
                this.$env.log.error(e);
                this.$_setState(states.error);
                this.$bugsnag.notify(e);
            } finally {
                this.$_setState(null, states.idle);
            }
        },
    },

    computed: {
        ...mapGetters(['getActor', 'getActorGallery', 'getImageSliderIndex', 'getShowCamera']),
    },
};
</script>
<style lang="less" scoped>
@import '~@variables';

[component='Gallery'] {
    [container='list'] {
        overflow-y: auto;
        align-items: flex-start;
        justify-content: flex-start;
        flex-grow: 1;
    }

    .my-images {
        display: flex;
        flex-wrap: wrap;
        align-items: flex-start;
        justify-content: flex-start;
        // height: calc(1000 - 80vw - 60px);
        padding-right: 15px;
        overflow-y: auto;
        // max-height: 500px;

        @media (orientation: landscape) {
            // height: calc(100% - 60px);
        }
    }

    #photoFile {
        display: none;
    }

    .buttons {
        width: 100%;
        display: flex;
        z-index: 40;
        padding-bottom: 15px;

        .camera {
            margin-right: 5px;

            &.disabled {
                background: grey;

                &:hover::before {
                    opacity: 0;
                }
            }
        }
    }

    .insideSlider {
        @media (min-width: 760px) {
            display: none;
        }
    }

    .button.save {
        width: ~'calc(100% - 15px)';
        margin-top: 20px;
    }
}
</style>
